module.exports = __webpack_public_path__ + "assets/img/house-4.4ecd6bc1.jpeg";